export const awsRegions = [
    { region: 'global', label: 'Global' },
    { region: 'north_america', label: 'North America' },
    { region: 'south_america', label: 'South America' },
    { region: 'europe', label: 'Europe' },
    { region: 'africa', label: 'Africa' },
    { region: 'asia_pacific', label: 'Asia Pacific' },
    { region: 'middle_east', label: 'Middle East' },
];


export const awsRegionsMapper = {
    0: 'global',
    1: 'north_america',
    2: 'south_america',
    3: 'europe',
    4: 'africa',
    5: 'asia_pacific',
    6: 'middle_east',
};